import React, { SVGProps } from 'react'

/**
 * Feature-local freeze glyph (matches the design prototype's snow icon). Lives
 * here rather than in src/components/Svgs, which `gen-svg-components` wipes and
 * regenerates from src/assets/svgs — this has no source asset.
 */
const SvgSnowflake = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.1}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 1v14M2 4.5l12 7M14 4.5l-12 7M8 1 6 3m2-2 2 2M8 15l-2-2m2 2 2-2M2 4.5l.2 2.7M2 4.5l2.7-.2M14 11.5l-.2-2.7M14 11.5l-2.7.2M14 4.5l-.2 2.7M14 4.5l-2.7-.2M2 11.5l.2-2.7M2 11.5l2.7.2"
    />
  </svg>
)
export default SvgSnowflake
